import React, { useState, useContext, useEffect } from "react";
import MainContainer from "../../components/MainContainer";
import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import ForbiddenPage from "../../components/ForbiddenPage";
import useHelps from "../../hooks/useHelps";
import { toast } from "react-toastify";
import { 
  Edit as EditIcon, 
  Delete as DeleteIcon, 
  Save as SaveIcon, 
  Close as CloseIcon, 
  Add as AddIcon,
  Visibility as VisibilityIcon
} from "@material-ui/icons";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import ConfirmationModal from "../../components/ConfirmationModal";

const useStyles = () => ({
  container: {
    padding: "24px",
    background: "#f5f7fa",
    minHeight: "100vh",
  },
  header: {
    marginBottom: "24px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "16px",
  },
  title: {
    fontSize: "28px",
    fontWeight: 700,
    color: "#1a1a1a",
    margin: 0,
  },
  formCard: {
    background: "white",
    borderRadius: "12px",
    padding: "24px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
    border: "1px solid #e8ecf1",
    marginBottom: "24px",
  },
  formGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "16px",
    marginBottom: "16px",
  },
  formGroup: {
    display: "flex",
    flexDirection: "column",
  },
  label: {
    fontSize: "12px",
    fontWeight: 600,
    color: "#666",
    marginBottom: "6px",
    display: "block",
  },
  input: {
    padding: "10px 12px",
    border: "1px solid #e8ecf1",
    borderRadius: "6px",
    fontSize: "13px",
    fontFamily: "inherit",
    background: "#fafbfc",
    transition: "all 0.2s ease",
  },
  textarea: {
    padding: "10px 12px",
    border: "1px solid #e8ecf1",
    borderRadius: "6px",
    fontSize: "13px",
    fontFamily: "inherit",
    background: "#fafbfc",
    transition: "all 0.2s ease",
    resize: "vertical",
    minHeight: "80px",
  },
  formActions: {
    display: "flex",
    gap: "12px",
    justifyContent: "flex-end",
    paddingTop: "16px",
    borderTop: "1px solid #e8ecf1",
    flexWrap: "wrap",
  },
  button: {
    padding: "10px 20px",
    background: "#3b82f6",
    color: "white",
    border: "none",
    borderRadius: "6px",
    fontSize: "13px",
    fontWeight: 600,
    cursor: "pointer",
    transition: "all 0.3s ease",
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  buttonSecondary: {
    padding: "10px 20px",
    background: "#e8ecf1",
    color: "#1a1a1a",
    border: "none",
    borderRadius: "6px",
    fontSize: "13px",
    fontWeight: 600,
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
  buttonDanger: {
    padding: "10px 20px",
    background: "#ef4444",
    color: "white",
    border: "none",
    borderRadius: "6px",
    fontSize: "13px",
    fontWeight: 600,
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
  tableCard: {
    background: "white",
    borderRadius: "12px",
    padding: "20px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
    border: "1px solid #e8ecf1",
    overflow: "hidden",
  },
  tableContainer: {
    overflowX: "auto",
    maxHeight: "calc(100vh - 300px)",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  tableHeader: {
    background: "#f9fafb",
    borderBottom: "2px solid #e8ecf1",
    position: "sticky",
    top: 0,
  },
  tableHeaderCell: {
    padding: "12px",
    textAlign: "center",
    fontSize: "12px",
    fontWeight: 700,
    color: "#666",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  tableRow: {
    borderBottom: "1px solid #e8ecf1",
    transition: "all 0.2s ease",
  },
  tableCell: {
    padding: "12px",
    fontSize: "13px",
    color: "#1a1a1a",
    textAlign: "center",
  },
  tableActions: {
    display: "flex",
    gap: "8px",
    justifyContent: "center",
    alignItems: "center",
  },
  iconButton: {
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "6px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "4px",
    transition: "all 0.2s ease",
    color: "#3b82f6",
  },
  emptyState: {
    textAlign: "center",
    padding: "40px 20px",
    color: "#999",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalContent: {
    background: "white",
    borderRadius: "12px",
    padding: "32px",
    boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
    maxWidth: "600px",
    width: "90%",
    maxHeight: "90vh",
    overflowY: "auto",
  },
  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "24px",
    paddingBottom: "16px",
    borderBottom: "1px solid #e8ecf1",
  },
  modalTitle: {
    fontSize: "20px",
    fontWeight: 700,
    color: "#1a1a1a",
    margin: 0,
  },
  closeButton: {
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#999",
    transition: "all 0.2s ease",
  },
  filterContainer: {
    background: "white",
    borderRadius: "12px",
    padding: "20px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
    border: "1px solid #e8ecf1",
    marginBottom: "24px",
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: "16px",
    alignItems: "flex-end",
  },
  filterGroup: {
    display: "flex",
    flexDirection: "column",
  },
  paginationContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px 20px",
    borderTop: "1px solid #e8ecf1",
    background: "#f9fafb",
    borderBottomLeftRadius: "12px",
    borderBottomRightRadius: "12px",
  },
  paginationInfo: {
    fontSize: "13px",
    color: "#666",
  },
  paginationButtons: {
    display: "flex",
    gap: "8px",
    alignItems: "center",
  },
  paginationButton: {
    padding: "8px 12px",
    background: "#e8ecf1",
    color: "#1a1a1a",
    border: "none",
    borderRadius: "6px",
    fontSize: "13px",
    fontWeight: 600,
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  paginationButtonActive: {
    background: "#3b82f6",
    color: "white",
  },
});

export default function Helps() {
  const styles = useStyles();
  const { user } = useContext(AuthContext);
  const { list, save, update, remove } = useHelps();

  const [loading, setLoading] = useState(false);
  const [records, setRecords] = useState([]);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    video: "",
    videoType: "youtube",
  });

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setLoading(true);
    try {
      const helpsList = await list();
      setRecords(helpsList);
      setCurrentPage(1);
    } catch (e) {
      toast.error("Erro ao carregar dados");
    }
    setLoading(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSelectRecord = (record) => {
    setFormData({
      id: record.id,
      title: record.title || "",
      description: record.description || "",
      video: record.video || "",
      videoType: record.videoType || "youtube",
    });
    setSelectedRecord(record);
    setShowModal(true);
  };

  const handleClear = () => {
    setFormData({
      title: "",
      description: "",
      video: "",
      videoType: "youtube",
    });
    setSelectedRecord(null);
    setShowModal(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (formData.id) {
        await update(formData);
      } else {
        await save(formData);
      }
      await loadData();
      handleClear();
      toast.success("Operação realizada com sucesso!");
    } catch (e) {
      toast.error("Erro ao salvar ajuda");
    }
    setLoading(false);
  };

  const handleDelete = async () => {
    setLoading(true);
    try {
      await remove(selectedRecord.id);
      await loadData();
      handleClear();
      setShowConfirmDialog(false);
      toast.success("Ajuda deletada com sucesso!");
    } catch (e) {
      toast.error("Erro ao deletar ajuda");
    }
    setLoading(false);
  };

  const filteredRecords = records.filter((record) =>
    record.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (record.description && record.description.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const totalPages = Math.ceil(filteredRecords.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedRecords = filteredRecords.slice(startIndex, endIndex);

  if (!user.super) {
    return <ForbiddenPage />;
  }

  return (
    <MainContainer>
      <div style={styles.container}>
        <div style={styles.header}>
          <h1 style={styles.title}>❓ {i18n.t("settings.tabs.helps")}</h1>
          <button
            onClick={() => {
              handleClear();
              setShowModal(true);
            }}
            style={{
              padding: "10px",
              background: "var(--primaryColor, #065183)",
              color: "white",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              transition: "all 0.3s ease",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onMouseEnter={(e) => {
              e.target.style.opacity = "0.9";
              e.target.style.transform = "translateY(-1px)";
              e.target.style.boxShadow = "0 2px 8px rgba(6, 81, 131, 0.3)";
            }}
            onMouseLeave={(e) => {
              e.target.style.opacity = "1";
              e.target.style.transform = "none";
              e.target.style.boxShadow = "none";
            }}
            title="Adicionar Ajuda"
          >
            <AddIcon style={{ fontSize: "20px" }} />
          </button>
        </div>

        {/* Filtros */}
        <div style={styles.filterContainer}>
          <div style={styles.filterGroup}>
            <label style={styles.label}>Buscar</label>
            <input
              style={styles.input}
              type="text"
              placeholder="Título ou descrição..."
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1);
              }}
            />
          </div>
        </div>

        {/* Tabela */}
        <div style={styles.tableCard}>
          <div style={styles.tableContainer}>
            {paginatedRecords.length === 0 ? (
              <div style={styles.emptyState}>
                <p>{records.length === 0 ? "Nenhuma ajuda cadastrada" : "Nenhuma ajuda encontrada"}</p>
              </div>
            ) : (
              <table style={styles.table}>
                <thead style={styles.tableHeader}>
                  <tr>
                    <th style={styles.tableHeaderCell}>Título</th>
                    <th style={styles.tableHeaderCell}>{i18n.t("helps.settings.description")}</th>
                    <th style={styles.tableHeaderCell}>Vídeo</th>
                    <th style={styles.tableHeaderCell}>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedRecords.map((record) => (
                    <tr key={record.id} style={styles.tableRow}>
                      <td style={styles.tableCell}>{record.title || "-"}</td>
                      <td style={styles.tableCell}>{record.description || "-"}</td>
                      <td style={styles.tableCell}>{record.video || "-"}</td>
                      <td style={styles.tableCell}>
                        <div style={styles.tableActions}>
                          <button
                            style={{
                              ...styles.iconButton,
                              color: "#10b981",
                            }}
                            onClick={() => handleSelectRecord(record)}
                            title="Visualizar"
                          >
                            <VisibilityIcon style={{ width: 18, height: 18 }} />
                          </button>
                          <button
                            style={styles.iconButton}
                            onClick={() => handleSelectRecord(record)}
                            title="Editar"
                          >
                            <EditIcon style={{ width: 18, height: 18 }} />
                          </button>
                          <button
                            style={{
                              ...styles.iconButton,
                              color: "#ef4444",
                            }}
                            onClick={() => {
                              setSelectedRecord(record);
                              setShowConfirmDialog(true);
                            }}
                            title="Deletar"
                          >
                            <DeleteIcon style={{ width: 18, height: 18 }} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
          {records.length > 0 && (
            <div style={styles.paginationContainer}>
              <div style={styles.paginationInfo}>
                Mostrando {startIndex + 1} a {Math.min(endIndex, filteredRecords.length)} de {filteredRecords.length} ajudas
              </div>
              <div style={styles.paginationButtons}>
                <button
                  style={{
                    ...styles.paginationButton,
                    opacity: currentPage === 1 ? 0.5 : 1,
                  }}
                  onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
                  disabled={currentPage === 1}
                >
                  ← Anterior
                </button>
                {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                  <button
                    key={page}
                    style={{
                      ...styles.paginationButton,
                      ...(currentPage === page ? styles.paginationButtonActive : {}),
                    }}
                    onClick={() => setCurrentPage(page)}
                  >
                    {page}
                  </button>
                ))}
                <button
                  style={{
                    ...styles.paginationButton,
                    opacity: currentPage === totalPages ? 0.5 : 1,
                  }}
                  onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
                  disabled={currentPage === totalPages}
                >
                  Próxima →
                </button>
              </div>
            </div>
          )}
        </div>

        <ConfirmationModal
          title="Deletar Ajuda"
          open={showConfirmDialog}
          onClose={() => setShowConfirmDialog(false)}
          onConfirm={handleDelete}
        >
          Tem certeza que deseja deletar esta ajuda? Esta ação não pode ser desfeita.
        </ConfirmationModal>

        {/* Modal de Edição */}
        <Modal
          style={styles.modal}
          open={showModal}
          onClose={handleClear}
          BackdropComponent={Backdrop}
          BackdropProps={{ style: { backgroundColor: "rgba(0, 0, 0, 0.5)" } }}
        >
          <div style={styles.modalContent}>
            <div style={styles.modalHeader}>
              <h2 style={styles.modalTitle}>
                {formData.id ? "Editar Ajuda" : "Nova Ajuda"}
              </h2>
              <button
                style={styles.closeButton}
                onClick={handleClear}
                type="button"
              >
                <CloseIcon style={{ width: 24, height: 24 }} />
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div style={styles.formGrid}>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Título</label>
                  <input
                    style={styles.input}
                    type="text"
                    name="title"
                    value={formData.title}
                    onChange={handleInputChange}
                    placeholder="Título da ajuda"
                    required
                  />
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Tipo de Vídeo</label>
                  <select
                    style={styles.input}
                    name="videoType"
                    value={formData.videoType}
                    onChange={handleInputChange}
                  >
                    <option value="youtube">YouTube</option>
                    <option value="drive">Google Drive</option>
                  </select>
                </div>
              </div>

              <div style={{ ...styles.formGrid, marginTop: "16px" }}>
                <div style={styles.formGroup}>
                  <label style={styles.label}>
                    {formData.videoType === "youtube" ? "ID do Vídeo do YouTube" : "ID do Vídeo do Google Drive"}
                  </label>
                  <input
                    style={styles.input}
                    type="text"
                    name="video"
                    value={formData.video}
                    onChange={handleInputChange}
                    placeholder={
                      formData.videoType === "youtube" 
                        ? "Ex: dQw4w9WgXcQ" 
                        : "Ex: 1a2b3c4d5e6f7g8h9i0j"
                    }
                  />
                  <small style={{ fontSize: "11px", color: "#666", marginTop: "4px", display: "block", lineHeight: "1.6" }}>
                    {formData.videoType === "youtube" ? (
                      <>Cole apenas o ID do vídeo do YouTube (ex: se a URL é youtube.com/watch?v=dQw4w9WgXcQ, use apenas dQw4w9WgXcQ)</>
                    ) : (
                      <>
                        <strong style={{ color: "#ef4444", display: "block", marginBottom: "8px" }}>⚠️ CONFIGURAÇÃO OBRIGATÓRIA DO GOOGLE DRIVE:</strong>
                        <strong>1. Compartilhamento:</strong>
                        <br />
                        • Abra o vídeo no Google Drive
                        <br />
                        • Clique em "Compartilhar" (canto superior direito)
                        <br />
                        • Em "Acesso geral", mude de "Restrito" para <strong>"Qualquer pessoa com o link"</strong>
                        <br />
                        • Certifique-se que está como "Leitor"
                        <br />
                        • Clique em "Concluído"
                        <br />
                        <br />
                        <strong>2. Extrair o ID:</strong>
                        <br />
                        • URL: drive.google.com/file/d/<strong style={{ color: "#3b82f6" }}>1a2b3c4d5e6f7g8h9i0j</strong>/view
                        <br />
                        • Use apenas: <strong style={{ color: "#3b82f6" }}>1a2b3c4d5e6f7g8h9i0j</strong>
                        <br />
                        <br />
                        <strong style={{ color: "#f59e0b" }}>💡 Dica:</strong> Se o vídeo não carregar, haverá um botão para abrir diretamente no Drive
                      </>
                    )}
                  </small>
                </div>
              </div>

              <div style={{ ...styles.formGrid, marginTop: "16px" }}>
                <div style={styles.formGroup}>
                  <label style={styles.label}>{i18n.t("helps.settings.description")}</label>
                  <textarea
                    style={styles.textarea}
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}
                    placeholder="Descrição da ajuda"
                    required
                  />
                </div>
              </div>

              <div style={styles.formActions}>
                <button
                  type="button"
                  style={styles.buttonSecondary}
                  onClick={handleClear}
                >
                  <CloseIcon style={{ width: 16, height: 16 }} />
                  {i18n.t("helps.settings.clear")}
                </button>
                {formData.id && (
                  <button
                    type="button"
                    style={styles.buttonDanger}
                    onClick={() => {
                      setShowConfirmDialog(true);
                    }}
                    disabled={loading}
                  >
                    <DeleteIcon style={{ width: 16, height: 16 }} />
                    {i18n.t("helps.settings.delete")}
                  </button>
                )}
                <button
                  type="submit"
                  style={styles.button}
                  disabled={loading}
                >
                  <SaveIcon style={{ width: 16, height: 16 }} />
                  {loading ? "Salvando..." : i18n.t("helps.settings.save")}
                </button>
              </div>
            </form>
          </div>
        </Modal>
      </div>
    </MainContainer>
  );
}
